"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPlayer = videoPlayer;
const youtube_api_1 = require("./youtube.api");
function videoPlayer(vid, elem, videoApi, analyticsService, youtubeApi, cookieHost) {
    const videoContainerEl = elem.querySelector('.video');
    if (videoContainerEl) {
        let frameHeight;
        let frameWidth;
        const previewImageElement = elem.querySelector('.video__previewImage');
        if (previewImageElement) {
            frameHeight = previewImageElement.clientHeight;
            frameWidth = previewImageElement.clientWidth;
        }
        previewImageElement.addEventListener('click', () => {
            const videoId = vid;
            if (!videoId)
                return;
            if (videoApi) {
                (0, youtube_api_1.attachYoutubePlayer)(videoContainerEl, frameHeight, frameWidth, videoId, analyticsService, youtubeApi, cookieHost);
            }
        });
    }
}
